import { CsvTemplateBuilder } from 'commons/utils/CSVTemplateBuilder';

const BinBulkUploadTemplate = new CsvTemplateBuilder('bin-bulk-upload');
BinBulkUploadTemplate.setHeader([
  'name',
  'bin_type',
  'warehouse_id',
  'commodity',
]);

BinBulkUploadTemplate.addRowValues(['A-01-01', 'retail', '1994', 'Prekursor']);
BinBulkUploadTemplate.addRowValues(['B-01-02', 'bulky', '1994', 'Obat']);
BinBulkUploadTemplate.addRowValues(['B-02-01', 'inbound', '1994', '']);

export { BinBulkUploadTemplate };
